import React from 'react';
import { motion } from 'framer-motion';
export const Terms = () => {
  return <main className="pt-32 pb-24 bg-brand-warm-white min-h-screen" data-id="element-520">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto px-6" data-id="element-521">
        <div className="mb-16" data-id="element-522">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-523">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-display text-brand-navy mb-6" data-id="element-524">
            Terms of Service
          </h1>
          <p className="text-brand-charcoal/60" data-id="element-525">Last updated: July 14, 2026</p>
        </div>

        <div className="space-y-12 text-brand-charcoal/80 leading-relaxed bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-navy/5" data-id="element-526">
          <section data-id="element-527">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-528">
              1. Agreement to Terms
            </h2>
            <p className="mb-4" data-id="element-529">
              By accessing our website and utilizing our services, you agree to
              be bound by these Terms of Service and all applicable laws and
              regulations. If you do not agree with any of these terms, you are
              prohibited from using or accessing this site.
            </p>
          </section>

          <section data-id="element-530">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-531">
              2. Professional Services
            </h2>
            <p className="mb-4" data-id="element-532">
              Consilium Advisory provides strategic consulting, financial
              advisory, and related services. The information provided on this
              website is for general informational purposes only and does not
              constitute professional financial, legal, or tax advice.
              Engagement of our services requires a formal written agreement.
            </p>
          </section>

          <section data-id="element-533">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-534">
              3. Intellectual Property
            </h2>
            <p className="mb-4" data-id="element-535">
              The content, organization, graphics, design, compilation, and
              other matters related to the Site are protected under applicable
              copyrights, trademarks, and other proprietary rights. The copying,
              redistribution, use, or publication by you of any such matters or
              any part of the Site is strictly prohibited.
            </p>
          </section>

          <section data-id="element-536">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-537">
              4. Limitation of Liability
            </h2>
            <p className="mb-4" data-id="element-538">
              In no event shall Consilium Advisory or its partners be liable for
              any damages (including, without limitation, damages for loss of
              data or profit, or due to business interruption) arising out of
              the use or inability to use the materials on our website, even if
              Consilium Advisory or an authorized representative has been
              notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section data-id="element-539">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-540">
              5. Governing Law
            </h2>
            <p className="mb-4" data-id="element-541">
              These terms and conditions are governed by and construed in
              accordance with the laws of the State of Maryland, United States,
              and you irrevocably submit to the exclusive jurisdiction of the
              courts in that State or location.
            </p>
          </section>
        </div>
      </motion.div>
    </main>;
};